var _ = require('lodash');
var defaults = require('./defaults');

module.exports = _.merge(defaults, {
    name: 'Prod',
    allowDebugLogs: false,
    listreportsUrl: 'https://www.listreports.com',
    google: {
        apiKey: 'AIzaSyDsj1nmsCSOA9-U1odURZBTqDmAmv3tH1Y'
    },
    listhub: {
        meterics_provider_id: 'M-5391',
        test: false
    },
    mixpanel: {
        id: '5014a17389ba7accd2f73f4ce977de26',
        debug: false
    },
    babou: {
        apiKey: 'cQ9FPlat9hTDppWRHIvPqx63t3KkEvVL',
        url: 'https://babou.listreports.com/v1'
    },
    whats_my_home_worth: {
        agent: 'H1Gk89XMx',
        vendor: 'B1OqGoYrl'
    },
    themesUrl: 'https://s3-us-west-2.amazonaws.com/listreports-templates/assets/themes-config.json'
});
